import { CurationItem } from "../../types";
import { createMenuContainer, getRequiredPublisherId, updateMenuContainer } from "./helpers";

/**
 * Creates a new header
 * @param parentId
 * @returns {Promise<CurationItem>}
 */
export const createHeader = async (parentId: string): Promise<CurationItem> => {
    if (!parentId) {
        throw new Error("createHeader requires a parentId.");
    }

    const publisherId = getRequiredPublisherId();
    const newHeader = await createMenuContainer(parentId, publisherId, "Header");

    const updateBody: CurationItem = {
        ...newHeader,
        title: "Header",
        metadata: {
            ...newHeader.metadata,
            default: {
                ...newHeader.metadata.default,
                "layout-menu-position": "Header",
            },
            en_US: {
                ...newHeader.metadata.en_US,
                title: "Header",
            },
        },
    };

    await updateMenuContainer(newHeader.id, updateBody, "Header");

    return newHeader;
};
